
const link = document.createElement('link');
link.setAttribute('rel', 'stylesheet');
link.setAttribute('type', 'text/css');
link.setAttribute(
	'href', 
	Liferay.ThemeDisplay.getPathContext() + '/o/frontend-taglib-clay/management_toolbar/CreationMenu.css'
);
document.querySelector('head').appendChild(link);
